import React, { useState } from 'react';
import Heading from '../../generic-components/Heading';
import Button from '../../generic-components/Button';
import { ISocialShareItem } from './types';
import { LinkShareTypes } from './consts';
import { ShareButtons } from './ShareButtons';

export const SocialShareItem = ({
  recipientName,
  invoiceNumber,
  paymentUrl,
  shareItems,
  onClick,
}: ISocialShareItem) => {
  const [decodedPaymentUrl] = useState<string>(decodeURIComponent(paymentUrl || ''));
  const subjectMsg = `Hi ${recipientName},`;
  const bodyMsg = `Here’s Invoice #${invoiceNumber} Thank you for your business. ${decodedPaymentUrl}`;

  const shareTypeCallback = (type: LinkShareTypes) => {
    switch (type) {
      case LinkShareTypes.Email:
        window.open(`mailto:?subject=${subjectMsg}&body=${bodyMsg}`);
        break;

      case LinkShareTypes.Facebook:
        window.open(
          `https://www.facebook.com/dialog/send?app_id=385908445601171&link=${paymentUrl}&redirect_uri=${paymentUrl}`,
        );
        break;

      case LinkShareTypes.WhatsApp:
        window.open(`whatsapp://send?text=${subjectMsg} ${bodyMsg}`);
        break;

      case LinkShareTypes.IMessage:
        window.open(`sms:&body=${subjectMsg} ${bodyMsg}`);
        break;
      default:
    }
  };
  const handleClick = (type: LinkShareTypes) => {
    if (onClick) {
      onClick(type);
    }
    shareTypeCallback(type);
  };

  return (
    <div className='flex items-center justify-between w-full'>
      {shareItems.map((i) => (
        <Button
          onClick={() => handleClick(i.type)}
          className=''
          id={`shareElement-${i.type}`}
          childElement={
            <div className='flex flex-col items-center w-[102px] px-[30px] py-[20px] hover:bg-bw02 rounded-[8px]'>
              <div className='w-[42px] h-[42px] min-w-[42px] min-h-[42px] mb-[16px]'>
                <ShareButtons
                  icon={i.iconAsset}
                  type={i.type}
                  bodyMsg={bodyMsg}
                  paymentUrl={paymentUrl}
                  subjectMsg={subjectMsg}
                />
              </div>
              <Heading title={i.title} className='font-metric text-[14px] heading-[16px] text-bw08' />
            </div>
          }
        />
      ))}
    </div>
  );
};
